export default "/images/vendor/flag-icons/flags/4x3/gr.svg?969458b727378ff7b215343cfc6c9165";